import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import NavRoutes from "./component/includes/NavRoutes";
import SidebarMenu from "./component/includes/SidebarMenu";
import Header from "./component/includes/Header";
import Footer from "./component/includes/Footer";
import { AuthProvider } from "./component/context/AuthContext";
import feather from "feather-icons";
import { GlobalModal } from "./component/admin/modal/GlobalModal";
import { Tooltip } from 'react-tooltip';

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const toggleSidebar = () => setSidebarCollapsed(prev => !prev);
  useEffect(() => {
    // Activate Feather icons
    window.feather.replace();
  }, []);
  return (
    <>
      <BrowserRouter basename="">
        <AuthProvider>
          <div className={`wrapper ${sidebarCollapsed ? "collapsed" : ""}`}>
            <SidebarMenu collapsed={sidebarCollapsed} />
            <div className="main">
              <Header toggleSidebar={toggleSidebar} />
              <div className="content">
                <NavRoutes />
                <GlobalModal />
              </div>
              <Footer />
            </div>
            <Tooltip id="tooltip" place="bottom" />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
